<template>
  <div>
    <file-uploader :compMode="compMode" entite="User"></file-uploader>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-user-circle-o"></i> {{ $t('user.create.title') }}
      </div>
      <div class="card-body">
        <errorMessage v-bind:message="error"></errorMessage>

        <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="firtNameInput">{{ $t('user.form.name') }}*</label>
            <input v-model.trim="user.firstName" v-validate="'required'" name="firstName" type="text" class="form-control" id="firtNameInput" placeholder="Prénom">
            <span class="text-danger" v-if="errors.has('firstName')">{{ $t('validations.required') }}</span>
          </div>
          <div class="form-group col-md-6">
            <label for="lastNameInput">{{ $t('user.form.surname') }}*</label>
            <input v-model.trim="user.lastName" v-validate="'required'" name="lastName" type="text" class="form-control" id="lastNameInput" placeholder="Nom">
            <span class="text-danger" v-if="errors.has('lastName')">{{ $t('validations.required') }}</span>
          </div>
        </div>

        <div class="form-group">
          <label for="emailInput">{{ $t('user.form.emailAddress') }}*</label>
          <input v-model.trim="user.emailAddress" v-validate="'required|email'" v-if="compMode != CRUDMODE.UPDATE"
            name="emailAddress" type="email" class="form-control" id="emailInput" placeholder="Courriel">
          <input v-model.trim="user.emailAddress" readonly v-validate="'required|email'" v-if="compMode == CRUDMODE.UPDATE"
            name="emailAddress" type="email" class="form-control" id="emailInput" placeholder="Courriel">
            
          <span class="text-danger" v-if="errors.has('emailAddress')">{{ $t('validations.required') }}</span>
        </div>

        <div class="form-group">
          <label for="phoneInput">{{ $t('user.form.phone') }}</label>
          <input v-model.trim="user.phoneNumber" type="text" class="form-control" id="phoneInput" placeholder="123-456-7890">
        </div>
        
        <div class="form-group">
          <label for="roleInput">{{ $t('user.form.roles') }}*</label>
        
          <multiselect
              id="roleNames"
              v-model="user.roleNames"
              :options="roles" 
              :multiple="true" 
              :taggable="false" 
              :customLabel="roleSelectLabel"
              v-bind:tag-placeholder="$t('multiselect.tag-placeholder')" 
              v-bind:select-label="$t('multiselect.select-label')"
              placeholder="" 
              :hide-selected="true"
              track-by="name"
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:selectedLabel="$t('multiselect.selectedLabel')">
          </multiselect>

          <input type="hidden" name="roleNames_validade" v-model="roleNames_validade" v-validate="'required'" />

          <span class="text-danger" v-if="errors.has('roleNames_validade')">{{ $t("validations.required") }}</span>

        </div>
    
        <view-event-person v-if="compMode != CRUDMODE.CREATE" :userId="user.id"></view-event-person>

        <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY" @click="createUser" class="btn btn-primary"> {{ $t('form.create_button') }}</span>
        <span v-if="compMode == CRUDMODE.UPDATE" @click="editUser" class="btn btn-primary">{{ $t('form.edit_button') }}</span>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {UserServiceClient, CreateUserDto, EditUserDto, UserDto, RoleServiceClient} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import ErrorMessage from '../ErrorMessage.vue'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import Multiselect from 'vue-multiselect'
import Enum from '@/shared/enum'
import ViewEventPerson from '../events/ViewEventPerson'

export default {
  name: 'CreateUser',
  mixins: [CrudMixin],
  data() {
    let dto = new CreateUserDto()
    dto.init()
    dto.roleNames = []

    return {
      ready: false,
      error: '',
      user: dto,
      roles: [],
    }
  },
  computed: {
    roleNames_validade: function() {
      if (this.user.roleNames != null && this.user.roleNames.length > 0) return 'notrequired'
      return ''
    },
  },
  methods: {
    manageEntity: function() {
      // Needs to convert the object because the one we receive on the fetch is slight different:
      // Has more props, and "roleNames" is an array of objects, not just and array of strings
      let cleanUser

      if (this.user.id == null) {
        cleanUser = new CreateUserDto()
      } else {
        cleanUser = new EditUserDto()
        cleanUser.id = this.user.id
      }

      cleanUser.firstName = this.user.firstName
      cleanUser.lastName = this.user.lastName
      cleanUser.emailAddress = this.user.emailAddress
      cleanUser.phoneNumber = this.user.phoneNumber

      cleanUser.roleNames = []

      for (var ix = 0; ix < this.user.roleNames.length; ix++) {
        cleanUser.roleNames.push(this.user.roleNames[ix].normalizedName)
      }

      return cleanUser
    },
    createUser: function() {
      this.$validator.validateAll().then(result => {
        if (result && this.ready) {
          let userService = ServiceFactory.create(UserServiceClient)

          userService
            .create(this.manageEntity())
            .then(res => this.persistFiles(res.id))
            .then(res => {
              this.$swal(this.$i18n.t('success'), '', 'success')
              this.$router.push({path: '/users'})
            })
            .catch(err => {
              this.processError(err, this)
            })
        }
      })
    },
    editUser: function() {
      this.$validator.validateAll().then(result => {
        if (result && this.ready) {
          let userService = ServiceFactory.create(UserServiceClient)

          userService
            .update(this.manageEntity())
            .then(res => this.persistFiles(res.id))
            .then(res => {
              this.$swal(this.$i18n.t('success'), '', 'success')
              this.$router.push({path: '/users'})
            })
            .catch(err => {
              this.processError(err, this)
            })
        }
      })
    },
    fetchData: function() {
      let roleService = ServiceFactory.create(RoleServiceClient)
      let userService = ServiceFactory.create(UserServiceClient)

      roleService
        .getAll()
        .then(res => {
          this.roles = res.items
          this.ready = true
        })
        .catch(err => {
          console.log(err)
        })

      if (this.compMode != Enum.Mode.CREATE) {
        let editUser = userService
          .get(this.$route.params.id)
          .then(res => {
            this.user = res
          })
          .catch(err => console.log(err))
      }
    },
    roleSelectLabel: function(option) {
      return option.displayName
    },
  },
  components: {
    errorMessage: ErrorMessage,
    multiselect: Multiselect,
    ViewEventPerson,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/users/Create.vue